module.exports = __webpack_public_path__ + "assets/img/facebook_609.ab3adeb8.png";